import type { ReactElement } from 'react';
import type { ContractStatusFilter, ContractTileCounts } from '../../domain/contracts';

interface ContractTilesProps {
  counts: ContractTileCounts;
  statusFilter: ContractStatusFilter;
  onStatusFilter: (filter: ContractStatusFilter) => void;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

export function ContractTiles({ counts, statusFilter, onStatusFilter }: ContractTilesProps): ReactElement {
  return (
    <section className="tiles-grid" data-testid="contracts-tiles">
      <article className={tileClass(statusFilter === 'all')} onClick={() => onStatusFilter('all')}>
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article className={tileClass(statusFilter === 'draft')} onClick={() => onStatusFilter('draft')}>
        <h3>Draft</h3>
        <p>{counts.draft}</p>
      </article>
      <article className={tileClass(statusFilter === 'active')} onClick={() => onStatusFilter('active')}>
        <h3>Active</h3>
        <p>{counts.active}</p>
      </article>
      <article className={tileClass(statusFilter === 'expired')} onClick={() => onStatusFilter('expired')}>
        <h3>Expired</h3>
        <p>{counts.expired}</p>
      </article>
      <article
        className={tileClass(statusFilter === 'terminated')}
        onClick={() => onStatusFilter('terminated')}
      >
        <h3>Terminated</h3>
        <p>{counts.terminated}</p>
      </article>
    </section>
  );
}
